import {
  Box,
  Card,
  CardContent,
  Chip,
  Link,
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Tooltip,
  Typography,
} from "@mui/material";
import React, { useEffect } from "react";
import { useSelector } from "react-redux";
import { AppFilter } from "../../../models/app/AppModels";
import { useGetQuotationsQuery } from "../../../redux/reducer/features/Quotation/quotationSlice";
import { AppState } from "../../../redux/reducer/rootReducer";
import { useNavigate } from "react-router-dom";

export const RecentLeads = () => {
  const { dmsSetup } = useSelector((state: AppState) => state.authReducer);
  const navigate = useNavigate();
  const [quotationsPaging, setQuotationsPaging] = React.useState<AppFilter>({
    pageIndex: 0,
    pageSize: 5,
    totalRecords: 0,
    items: [],
    quickFilterValues: [],
  });
  const [quotations, setQuotations] = React.useState<any[]>([]);
  const {
    data: quotationsData,
    isLoading: quotationsLoading,
    refetch: refetchQuotations,
    isFetching: quotationsFetching,
  } = useGetQuotationsQuery(
    {
      paging: quotationsPaging,
    },
    { skip: dmsSetup?.id === undefined ? true : false }
  );

  useEffect(() => {
    if (quotationsData && quotationsData.entityList) {
      setQuotations(quotationsData.entityList);
    }
  }, [quotationsData]);

  useEffect(() => {
    refetchQuotations();
  }, []);

  const handleRedirect = (URL: string) => {
    navigate(URL);
  };
  return (
    <Card>
      <CardContent>
        <Box display="flex" alignItems="center" justifyContent="space-between">
          <Box display="flex" fontWeight={"bold"}>
            Recent Leads
          </Box>
          <Box>
            <Link
              onClick={() => {
                handleRedirect("Leads");
              }}
              sx={{ cursor: "pointer" }}
              variant="body2"
            >
              View All
            </Link>
          </Box>
        </Box>
        <Box
          sx={{
            mt: 1,
            minHeight: "290px",
            display: "flex",
            justifyContent: "center",
            alignItems: "flex-start",
          }}
        >
          {quotations.length === 0 ? (
            <Typography mt={"130px"} style={{ fontSize: "14px" }}>
              {quotationsLoading || quotationsFetching
                ? "Loading data..."
                : "No data to display"}
            </Typography>
          ) : (
            <TableContainer component={Paper} sx={{ overflowX: "auto" }}>
              <Table sx={{ minWidth: 600 }} size="medium">
                <TableHead>
                  <TableRow>
                    <TableCell sx={{ fontWeight: "bold", p: 1.6 }}>
                      Name
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", p: 1.6 }}>
                      Phone
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", p: 1.6 }}>
                      Message
                    </TableCell>
                    <TableCell sx={{ fontWeight: "bold", p: 1.6 }}>
                      Title
                    </TableCell>
                  </TableRow>
                </TableHead>
                <TableBody>
                  {quotations.map((item, index) => (
                    <TableRow
                      key={index}
                      sx={{
                        "&:last-child td, &:last-child th": {
                          border: 0,
                        },
                      }}
                    >
                      <TableCell sx={{ p: 1.6, whiteSpace: "nowrap" }}>
                        {item.firstName} {item.lastName}
                        {!item.acknowledged && (
                          <Chip
                            label="New"
                            size="small"
                            color="info"
                            sx={{
                              marginLeft: 1,
                              height: "18px",
                              fontSize: "0.7rem",
                            }}
                          />
                        )}
                      </TableCell>
                      <TableCell sx={{ p: 1.6 }}>
                        {item.phone ?? "N/A"}
                      </TableCell>
                      <TableCell sx={{ p: 1.6, whiteSpace: "nowrap" }}>
                        {item.message && item.message.length > 25 ? (
                          <Tooltip title={item.message}>
                            <span>
                              {item.message.substring(0, 25)}
                              {"..."}
                            </span>
                          </Tooltip>
                        ) : (
                          item.message
                        )}
                      </TableCell>
                      <TableCell sx={{ p: 1.6, whiteSpace: "nowrap" }}>
                        {item?.productAggregate?.title ?? "N/A"}
                      </TableCell>
                    </TableRow>
                  ))}
                </TableBody>
              </Table>
            </TableContainer>
          )}
        </Box>
      </CardContent>
    </Card>
  );
};
